<script lang="ts">
  import { getImageStyle, styleToString } from "@shared/common/node/style";
  import type {
    IImageNode,
    IMediaPaint,
    PartialNode,
  } from "@shared/common/node/type";
  import { getBackgroundPositionStyle } from "@shared/common/node/util";
  import detectReaction from "../../actions/detect-reaction";
  import { getCurrentDocumentNode, getStore } from "../../context";
  import Video from "./video.svelte";

  const { reactionEventListener } = getStore();

  const documentNode = getCurrentDocumentNode();

  export let node: PartialNode<IImageNode>;

  function getImageFill(node: PartialNode<IImageNode>): IMediaPaint | null {
    const imageFill = node.fills?.[0];
    if (imageFill?.type === "IMAGE") {
      return imageFill;
    }
    return null;
  }

  $: image = getImageFill(node);
  $: hasObjectFitMode = !!image?.backgroundSize;
</script>

{#if image}
  {#if hasObjectFitMode}
    <div
      use:detectReaction={{
        node,
        documentNode,
        onAction: reactionEventListener,
      }}
      style={styleToString({
        position: "relative",
        ...getImageStyle(node),
      })}
    >
      <img
        src={image.path}
        style={styleToString({
          width: "100%",
          height: "100%",
          objectFit: image.backgroundSize === "CONTAIN" ? "contain" : "cover",
          objectPosition: getBackgroundPositionStyle(
            image.backgroundPosition ?? "CENTER"
          ),
        })}
        alt={node.id}
      />
    </div>
  {:else if image.width && image.height}
    <div
      use:detectReaction={{
        node,
        documentNode,
        onAction: reactionEventListener,
      }}
      style={styleToString({
        position: "relative",
        ...getImageStyle(node),
      })}
    >
      <div
        style={styleToString({
          position: "relative",
          paddingBottom: `${(image.height.value / image.width.value) * 100}%`,
        })}
      >
        <img
          src={image.path}
          style={styleToString({
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
          })}
          alt={node.id}
        />
      </div>
    </div>
  {:else}
    <img
      use:detectReaction={{
        node,
        documentNode,
        onAction: reactionEventListener,
      }}
      src={image.path}
      style={styleToString(getImageStyle(node))}
      alt={node.id}
    />
  {/if}
{:else if node.videoInfo && node.videoInfo.fileName}
  <Video {node} />
{/if}
